import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'

import CreateBrandModal from '@modals/CreateBrandModal'

import PageContent from './components/PageContent'

const callbacks = (component, setState) => {
  const componentCallbacks = {
    CreateBrandModal: {
      closeModal: () => setState({ showCreateBrandModal: false }),
      createBrand: payload => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreateBrandModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreateBrandModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreateBrandModal: () => setState({ showCreateBrandModal: true }),
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <CreateBrandModal
          callbacks={callbacks('CreateBrandModal', setState)}
          showModal={showCreateBrandModal}
        />

        <PageContent pageFilters={pageFilters} />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
